module.exports = __webpack_public_path__ + "img/comment-blue.a783abf6.svg";